import EmailSuccessView from './views/EmailSuccessView';

export function EmailSuccess() {
    return (
        <>
            <EmailSuccessView />
        </>
    );
}
